export const SUCCESS = {
  DARKEST: '#004E46',
  DARKER: '#08655C',
  DARK: '#00766A',
  DEFAULT: '#00897B',
  LIGHT: '#B9E6CD',
  LIGHTER: '#E0F2E3',
  LIGHTEST: '#F0F9F4',
} as const;
